import Vue from 'vue'
import Vuex from 'vuex'
import auth from '../../store/modules/auth'
import progress from '../../store/modules/progress'
import getters from '../../store/getters'
import mutations from '../../store/mutations'
import rootState from '../../store/state'
import { getTokenName } from '../../logic/token'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    auth,
    progress,
  },
  getters,
  mutations,
  state: rootState,
  strict: debug,
})

store.subscribe((mutation, state) => {
  // accessTokenをlocalStorageに保存
  localStorage.setItem(getTokenName(), state.auth.token)

  // サイドバー状態をlocalStorageに保存
  localStorage.setItem('isSidebarCollapsed', state.isSidebarCollapsed)
})

export default store
